module.exports = __webpack_public_path__ + "img/TO.7792164f.svg";